import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isSessionActive, clearSession } from "../services/authService";

export default function ProtectedRoute() {
  const location = useLocation();
  const active = isSessionActive(15); //Tiempo de inactividad en minutos

  if (!active) {
    clearSession();
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
